import { Box } from "@mui/material";
import React from "react";

import AboutSectionOne from "./AboutSectionOne";
import AboutSectionTwo from "./AboutSectionTwo";
import HeroSectionAbout from "./HeroSectionAbout";

const AboutUs: React.FC = () => {
  return (
    <Box>
      <HeroSectionAbout />
      <AboutSectionOne />
      <AboutSectionTwo />
    </Box>
  );
};

export default AboutUs;
